import {NgModule} from '@angular/core';
import {APP_CONFIG} from '@app/config/AppConfig';
import {CdsModule} from '@spartacus/cds';
import {Config, provideConfig} from '@spartacus/core';

@NgModule({
  declarations: [],
  imports: [CdsModule.forRoot()],
  providers: [provideConfig(APP_CONFIG as Config)],
})
export class CdsFeatureModule {}
